import {useMemo} from 'react'

import {
  coolerSectionDefaultValues,
  coolerBaghouseSectionDefaultValues,
  kilnSectionDefaultValues,
  housekeepingSectionDefaultValues,
  additionalCommentsSectionDefaultValues
} from '../config'
import {
  CoolerSectionFields,
  CoolerBaghouseSectionFields,
  KilnSectionFields,
  HousekeepingSectionFields,
  AdditionalCommentsSectionFields
} from '../containers/KilnChecksheet'
import {type StepsConfig, useWidgetTranslation} from '../hooks'
import {
  getCoolerSectionValidationSchema,
  getCoolerBagHouseSectionValidationSchema,
  getKilnSectionValidationSchema,
  getHousekeepingSectionValidationSchema,
  getAdditionalCommentsSectionValidationSchema
} from '../validators'

export const useKilnCheckSheetStepsConfig = (): StepsConfig => {
  const {t} = useWidgetTranslation()

  return useMemo(() => {
    return [
      {
        key: 'coolerSection',
        label: t('kilnCheckSheet.label.coolerSection'),
        StepFormContent: CoolerSectionFields,
        validationSchema: getCoolerSectionValidationSchema({t}),
        defaultValues: coolerSectionDefaultValues
      },
      {
        key: 'coolerBaghouseSection',
        label: t('kilnCheckSheet.label.coolerBaghouseSection'),
        StepFormContent: CoolerBaghouseSectionFields,
        validationSchema: getCoolerBagHouseSectionValidationSchema({t}),
        defaultValues: coolerBaghouseSectionDefaultValues
      },
      {
        key: 'kilnSection',
        label: t('kilnCheckSheet.label.kilnSection'),
        StepFormContent: KilnSectionFields,
        validationSchema: getKilnSectionValidationSchema({t}),
        defaultValues: kilnSectionDefaultValues
      },
      {
        key: 'housekeepingSection',
        label: t('kilnCheckSheet.label.housekeepingSection'),
        StepFormContent: HousekeepingSectionFields,
        validationSchema: getHousekeepingSectionValidationSchema({t}),
        defaultValues: housekeepingSectionDefaultValues
      },
      {
        key: 'additionalCommentsSection',
        label: t('kilnCheckSheet.label.additionalCommentsSection'),
        StepFormContent: AdditionalCommentsSectionFields,
        validationSchema: getAdditionalCommentsSectionValidationSchema({t}),
        defaultValues: additionalCommentsSectionDefaultValues
      }
    ]
  }, [t])
}
